export const fuchsia = {
  900: '#500663',
  800: '#71088B',
  700: '#880AA8',
  600: '#9C0BC0',
  500: '#AD0DD5',
  400: '#CB67E4',
  300: '#DB94EC',
  200: '#E6B6F2',
  100: '#EFD2F7',
  50: '#F7E9FB',
}
